import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class TeachersTrainingAidForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            required={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="product"
                            required={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Termék"
                        />
                    </div>
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="school_year"
                            values={this.props.values}
                            type="number"
                            setFieldValue={this.props.setFieldValue}
                            label="Osztály"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("type")}
                            optionname="TeachersTrainingAidType"
                            storeType="local"
                            objectValue={false}
                            name="type"
                            required={true}
                            value={this.props.values.type}
                            label="Típus"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            name="tags"
                            component={this.props.componentConfig.fielddefs.tags.objects}
                            value={this.props.values.tags}
                            saveChanges={this.props.setFieldValue}
                            isMulti={true}
                            label="Cimkék"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="training_aid"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Dokumentum"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TeachersTrainingAidForm);
